<div class="sc-search-container" [ngClass]="{ 'schedules-ff': hasSchedulesFF, 'no-schedules-ff': !hasSchedulesFF }">
	<div *ngIf="loading" class="sc-loading-box">
		<mat-spinner></mat-spinner>
	</div>
	<div style="position: relative" *ngIf="!loading">
		<div class="search-box-container" [ngClass]="{ inactive: !isSearchFocused, full: overLimit > 0 }" (click)="setFocusOnSearch()">
			<div *ngFor="let selection of selectedGroupsAndStudents">
				<app-selection [selection]="selection" [isUser]="isUser(selection)" (removeSelectionEvent)="removeSelection($event)"></app-selection>
			</div>
			<input
				#searchInput
				class="dynamic-search-box"
				[placeholder]="selectedGroupsAndStudents.length === 0 ? 'Search students & groups' : ''"
				[(ngModel)]="searchText"
				(input)="searchInputChanges$.next($event.target?.value)"
				(focus)="onSearchFocus(true)"
				(blur)="onSearchFocus(false)" />
		</div>
		<!-- TODO this entire div can be replaced with sp-search-and-results component, which incorporates sp-upload-student-list
		 see example usage in sp-student-group-select  -->
		<div
			*ngIf="isSearchFocused && (searchResults?.length !== 0 || searchText.length === 0 || usersLoaded) && overLimit <= 0"
			class="sc-search-results groups-students-list tw-pl-2 tw-pr-2">
			<mat-list>
				<mat-list-item [style.padding]="'0'" *ngIf="searchText?.length === 0">
					<sp-upload-student-list (handleClick)="showImportStudentList()"></sp-upload-student-list>
				</mat-list-item>

				<mat-list-item
					*ngFor="let group of groups"
					class="sc-search-group"
					(mousedown)="onSelect(group)"
					[style.background-color]="getBackground(_item)"
					#_item>
					<div class="sc-search-selection tw-flex tw-gap-2 tw-items-center">
						<div class="tw-flex tw-items-center">
							<img class="tw-rounded-full" style="width: 28px; height: 28px" src="../../../../../assets/Groups Icon.svg" />
						</div>
						<div class="tw-flex tw-items-center tw-gap-1 tw-leading-none">
							<div class="sc-search-name tw-font-medium tw-flex-grow tw-text-[15px]">{{ group.title }}</div>
							<div class="tw-font-light tw-text-sm tw-text-navy-500 tw-leading-none">
								{{ group.users.length }}
								<ng-container [ngPlural]="group.users.length">
									<ng-template ngPluralCase="=1"> student</ng-template>
									<ng-template ngPluralCase="other"> students</ng-template>
								</ng-container>
							</div>
						</div>
					</div>
				</mat-list-item>

				<mat-list-item
					*ngFor="let result of searchResults"
					class="sc-search-group"
					[ngClass]="{ 'cant-add': !result.overwriteable }"
					(mousedown)="onSelect(result)"
					#_item>
					<div
						class="sc-search-selection tw-items-center tw-flex tw-gap-2"
						[ngClass]="{ 'cant-add': !result.overwriteable }"
						[customToolTip]="result.message ?? ''">
						<div
							*ngIf="result.user.profile_picture; else d"
							[ngStyle]="{ background: 'url(' + result.user.profile_picture + ') no-repeat left center/cover' }"
							class="profile-picture"></div>
						<ng-template #d>
							<img class="profile-picture" src="../../../../../assets/Avatar Default.svg" alt="Avatar" />
						</ng-template>
						<span class="sc-search-name">{{ result.user.display_name }}</span>
						<div class="sc-search-message" *ngIf="result?.activityName">
							<img src="../../../../../assets/Check (Gray).svg" alt="Already in" /><span
								>{{ result?.alreadyIn ? 'Already in' : 'In' }} {{ result.activityName }}</span
							>
						</div>
					</div>
				</mat-list-item>
				<div *ngIf="groups.length === 0 && searchResults?.length === 0 && searchText.length > 0 && usersLoaded" class="no-results-found-container">
					No Results Found
				</div>
			</mat-list>
		</div>
		<div *ngIf="overLimit > 0" class="occupancy-warning">
			<img src="../../../../../assets/barcodeScanErrorIcon.svg" />
			<div>Only {{ spotsRemaining }} spot<span *ngIf="spotsRemaining !== 1">s</span> left in this activity.</div>
		</div>
		<div class="overwriteable-list" *ngIf="overrideableStudents.length > 0">
			<div class="sc-add-all-header">
				<img src="../../../../../assets/Info (Blue-Gray).svg" />
				<div>
					<div>
						{{ overrideableStudents.length }}
						<ng-container [ngPlural]="overrideableStudents.length">
							<ng-template ngPluralCase="=1"> Student</ng-template>
							<ng-template ngPluralCase="other"> Students</ng-template>
						</ng-container>
						Not Added
					</div>
					<span
						>They are already in
						<ng-container [ngPlural]="overrideableStudents.length">
							<ng-template ngPluralCase="=1"> another activity</ng-template>
							<ng-template ngPluralCase="other"> other activities</ng-template> </ng-container
						>.
					</span>
				</div>
				<div
					class="sc-add-all-btn"
					[ngClass]="{ 'cant-add': overrideAllDisabled }"
					(click)="!overrideAllDisabled && overrideAll()"
					[customToolTip]="overrideAllDisabled ? 'One or more students can\'t be added.' : ''">
					Add Anyway
				</div>
			</div>
			<div *ngFor="let result of overrideableStudents">
				<mat-list-item
					class="sc-search-group"
					(click)="overrideStudent(result.user.id)"
					[style.background-color]="getBackground(_item)"
					#_item
					[ngClass]="{ 'cant-add': !result.overwriteable }">
					<div
						class="sc-search-selection"
						[ngClass]="{ 'cant-add': !result.overwriteable }"
						[style.opacity]="result.overwriteable ? '100%' : '50%'"
						[customToolTip]="result.message ?? ''">
						<div
							*ngIf="result.user.profile_picture; else d"
							[ngStyle]="{ background: 'url(' + result.user.profile_picture + ') no-repeat left center/cover' }"
							class="profile-picture"></div>
						<ng-template #d>
							<img class="profile-picture" src="../../../../../assets/Avatar Default.svg" alt="Avatar" />
						</ng-template>
						<span class="sc-search-name">{{ result.user.display_name }}</span>
						<div class="sc-search-message" *ngIf="result?.activityName">
							<img src="../../../../../assets/Check (Gray).svg" alt="Yeah" /><span
								>{{ result?.alreadyIn ? 'Already in' : 'In' }} {{ result.activityName }}</span
							>
						</div>
					</div>
				</mat-list-item>
			</div>
		</div>
		<div class="footer-list-bar" *ngIf="overrideableStudents.length > 0"></div>
		<div class="attendee-add-footer">{{ footerText }}</div>
	</div>
</div>
